import type { ReactNode } from "react";

import { Badge, type BadgeVariant } from "../../design-system";

export function Status({
  children,
  tone = "neutral",
  active = false,
  className,
}: {
  children: ReactNode;
  tone?: BadgeVariant;
  active?: boolean;
  className?: string;
}) {
  return (
    <Badge variant={tone} size="sm" className={className}>
      {active && <span className="pill-dot" aria-hidden="true" />}
      {children}
    </Badge>
  );
}
